// extracted by mini-css-extract-plugin
export default {"General":"General_General__7pXWf","Prices":"General_Prices__lSIyO"};